// extracted by mini-css-extract-plugin
module.exports = {"helpLink":"ForgotPassword_helpLink__qocwO"};